import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Reviews from './components/Reviews';
import Services from './components/Services';
import Gallery from './components/Gallery';
import About from './components/About';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import PriceList from './components/PriceList';
export function App() {
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Reviews data-id="element-4" />
        <Services data-id="element-5" />
        <PriceList data-id="element-6" />
        <About data-id="element-7" />
        <Gallery data-id="element-8" />
        <ContactForm data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}